import React, { useState, useEffect, lazy, Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Home from '@/pages/Home';
import ComingSoon from '@/pages/ComingSoon';
import { API } from '@/utils/apiConfig';

const EnergomatHome = lazy(() => import('@/pages/EnergomatHome'));
const RestaurantHome = lazy(() => import('@/pages/RestaurantHome'));
const FitnessHome = lazy(() => import('@/pages/FitnessHome'));
const PortfolioHome = lazy(() => import('@/pages/PortfolioHome'));
const IceCreamHome = lazy(() => import('@/pages/IceCreamHome'));
const AutoservisHome = lazy(() => import('@/pages/AutoservisHome'));
const CarpentryHome = lazy(() => import('@/pages/CarpentryHome'));
const EshopHome = lazy(() => import('@/pages/EshopHome'));
const ZubarPrahaHome = lazy(() => import('@/pages/ZubarPrahaHome'));
const LoxoneSmartHome = lazy(() => import('@/pages/LoxoneSmartHome'));
const RevizeElektroHome = lazy(() => import('@/pages/RevizeElektroHome'));
const DotaceHome = lazy(() => import('@/pages/DotaceHome'));
const PenbHome = lazy(() => import('@/pages/PenbHome'));
const AutodilyHome = lazy(() => import('@/pages/AutodilyHome'));
const JanecekInvestHome = lazy(() => import('@/pages/JanecekInvestHome'));

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-900">
    <div className="w-8 h-8 border-2 border-sky-500 border-t-transparent rounded-full animate-spin" />
  </div>
);

const TEMPLATES = {
  energomat: EnergomatHome,
  restaurant: RestaurantHome,
  fitness: FitnessHome,
  portfolio: PortfolioHome,
  icecream: IceCreamHome,
  autoservis: AutoservisHome,
  carpentry: CarpentryHome,
  eshop: EshopHome,
  'zubar-praha': ZubarPrahaHome,
  'loxone-smart-home': LoxoneSmartHome,
  'revize-elektro': RevizeElektroHome,
  dotace: DotaceHome,
  penb: PenbHome,
  autodily: AutodilyHome,
  'janecek-invest': JanecekInvestHome,
};

export default function SiteRouter() {
  const [layout, setLayout] = useState(null);
  const [searchParams] = useSearchParams();
  const siteId = searchParams.get('site_id') || '';

  useEffect(() => {
    try {
      for (let i = sessionStorage.length - 1; i >= 0; i--) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith('sg_cache_')) sessionStorage.removeItem(key);
      }
    } catch {}

    setLayout(null);
    axios.get(`${API}/site-layout`)
      .then(r => {
        setLayout(r.data.layout || 'default');
      })
      .catch(() => {
        setLayout('default');
      });
  }, [siteId]);

  if (layout === null) return null;
  if (layout === 'coming_soon') return <ComingSoon />;

  const Template = TEMPLATES[layout];
  if (Template) return <Suspense fallback={<Loader />}><Template /></Suspense>;
  return <Home />;
}
